import { useEffect, useState } from 'react';
import { getAuthTokensService, TokensDTO } from './AuthTokensService';

export const useAuth = () => {
  const [credentials, setCredentials] = useState<TokensDTO | null>(null);
  const [rolesFromToken, setRolesFromToken] = useState<string[] | null>(null);
  const [authTenantId, setAuthTenantId] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const authService = getAuthTokensService();

    const credentialsSubscription = authService.credentials.subscribe((creds) => {
      setCredentials(creds);
    });

    const initializedSubscription = authService.isInitialized$.subscribe((initialized) => {
      if (initialized) {
        setIsLoading(false);
      }
    });

    const rolesSubscription = authService.rolesFromToken$.subscribe((roles) => {
      setRolesFromToken(roles);
    });

    const tenantSubscription = authService.authTenantId$.subscribe((tenantId) => {
      setAuthTenantId(tenantId);
    });

    return () => {
      credentialsSubscription.unsubscribe();
      initializedSubscription.unsubscribe();
      rolesSubscription.unsubscribe();
      tenantSubscription.unsubscribe();
    };
  }, []);

  return {
    credentials,
    rolesFromToken,
    authTenantId,
    isLoading,
    isAuthenticated: !!credentials?.access_token?.token,
  };
};